import { useTranslation } from "react-i18next";	
import programImage1 from "../../../assets/images/programs/programImage1.jpg";
import programImage2 from "../../../assets/images/programs/programImage2.jpg";
import programImage3 from "../../../assets/images/programs/programImage3.jpg";

export const programInfo = [
	{
		id: "personal-boundaries",
		nameKey: "programs.p1_short_name",
		image: programImage1,
		shortDescKey: "programs.p1_short_desc",
		description: (lang) =>
			lang === "en" ? (
				<>
					<p className="singlePostDesc pb-5">
						Learning how to set personal boundaries is a fundamental skill for
						emotional health, inner peace, and fulfilling relationships. When
						boundaries are missing, we become exhausted and live in constant
						inner tension.
					</p>
					<p className="singlePostDesc pb-5">
						This one-month online program is designed to help you build healthy
						boundaries and return to a sense of stability, calm, and clarity.
					</p>
					<p className="singlePostDesc pb-5">
						“Set Boundaries and Live in Inner Peace” is a structured therapeutic
						and coaching process that guides you step by step through
						understanding, building, and maintaining personal boundaries in all
						areas of life. The approach combines psychological insight and life
						coaching techniques with practical exercises that lead to real and
						sustainable change.
					</p>
					<p className="singlePostDesc pb-5">
						<b>What is included in the program?</b>
					</p>
					<ul>
						<li>
							14 lectures, divided into two parts (video and written materials);
						</li>
						<li>
							weekly live discussion sessions with practical exercises and my
							personal support;
						</li>
						<li>
							a Telegram chat channel for sharing, questions, and mutual support
							among participants;
						</li>
					</ul>
					<p className="singlePostDesc pb-5">
						<b>Module 1: Introduction to Personal Boundaries</b>
					</p>
					<p className="singlePostDesc pb-5">
						What are personal boundaries and why are they essential?
					</p>
					<p className="singlePostDesc pb-5">
						<ul className="pb-5">
							<li>
								What personal boundaries are and how they affect emotional and
								mental health;
							</li>
							<li>Expectations and needs in relationships;</li>
							<li>Boundaries as a form of self-care;</li>
							<li>
								How lack of boundaries leads to exhaustion and over-giving;
							</li>
							<li>Signs of violated or missing boundaries;</li>
							<li>
								The connection between trauma and the inability to say “NO”;
							</li>
						</ul>
					</p>
					<p className="singlePostDesc pb-5">Practical exercises:</p>
					<ul className="pb-5">
						<li>
							Self-reflection: “What do my boundaries look like right now?”
						</li>
						<li>Exercise: “First steps in identifying healthy boundaries”</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Module 2: Reasons for the Lack of Boundaries
					</p>
					<p className="singlePostDesc pb-5">
						Why do we struggle to set boundaries?
					</p>
					<ul>
						<li>The influence of family environment and upbringing;</li>
						<li>Childhood trauma and its impact on adult relationships;</li>
						<li>Fear of rejection and conflict;</li>
						<li>People-pleasing patterns;</li>
						<li>Unrealistic expectations and the “superhero” role;</li>
						<li>
							The six types of boundaries: physical, emotional, time-related,
							sexual, intellectual, and material;
						</li>
					</ul>
					<p className="singlePostDesc pb-5">Practical exercises:</p>
					<ul>
						<li>Exercise: “In which areas do I most often compromise?”</li>
						<li>Practicing saying “NO” – example scenarios and role-play</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Module 3: Building Healthy Boundaries
					</p>
					<p className="singlePostDesc pb-5">
						How do we recognize, express, and protect our boundaries?
					</p>
					<ul>
						<li>Recognizing personal needs;</li>
						<li>Confidently expressing desires and positions;</li>
						<li>
							Boundaries in different areas of life – family, romantic
							relationships, friendships, workplace, social media, and
							technology;
						</li>
						<li>Techniques for managing conflict situations;</li>
					</ul>
					<p className="singlePostDesc pb-5">Practical exercises:</p>
					<ul>
						<li>Exercise: “My new boundaries in every area of life”</li>
						<li>Meditation: “Healthy personal space”</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Module 4: Maintaining Inner Peace
					</p>
					<p className="singlePostDesc pb-5">
						How can we live in balance without sacrificing ourselves?
					</p>
					<ul>
						<li>Boundaries as part of everyday life;</li>
						<li>Adapting boundaries as life changes;</li>
						<li>How to respond when boundaries are violated;</li>
						<li>Recognizing manipulation and toxic behavior;</li>
						<li>The freedom to be yourself and live authentically;</li>
					</ul>
					<p className="singlePostDesc pb-5">Practical exercises:</p>
					<ul>
						<li>Ritual: “I forgive and I release”</li>
						<li>Creating a personal manifesto for balance and inner peace</li>
					</ul>
					<p className="singlePostDesc pb-5">
						The program includes 14 lectures that you can watch and read at a
						time convenient for you, weekly live sessions (1 hour each) for
						questions and practice, and ongoing support through a Telegram chat
						channel.
					</p>
					<p className="singlePostDesc pb-5">
						By the end of the program, you will have a clear understanding of
						what personal boundaries are and why they are essential for your
						quality of life. You will learn how to recognize and express your
						needs, build new healthy communication patterns, and live with
						greater inner peace, confidence, and balance—without sacrificing
						yourself.
					</p>
					<p className="singlePostDesc pb-5">
						The program starts on the 1st day of each month. This is an
						invitation to take the first step toward a calmer, more conscious,
						and balanced life.
					</p>
					<p className="singlePostDesc">
						The program starts on the 1st day of each month.
					</p>
				</>
			) : (
				<>
					<p className="singlePostDesc pb-5">
						Да умеем да поставяме лични граници е основно умение за емоционално
						здраве, вътрешен мир и пълноценни взаимоотношения. Когато границите
						липсват или са нарушени, ние се изтощаваме, губим себе си и живеем в
						постоянен вътрешен конфликт.
					</p>
					<p className="singlePostDesc pb-5">
						Тази едномесечна онлайн програма е създадена, за да ви помогне да
						изградите здравословни граници и да се върнете към усещането за
						стабилност, спокойствие и яснота.
					</p>
					<p className="singlePostDesc pb-5">
						Програмата „Постави граници и заживей във вътрешен мир“ представлява
						структуриран терапевтичен и коучинг процес, който ви води стъпка по
						стъпка през разбирането, изграждането и поддържането на лични
						граници във всички сфери на живота. Подходът съчетава психологически
						знания и лайф коучинг техники с практически упражнения, които водят
						до реална и устойчива промяна.
					</p>
					<p className="singlePostDesc pb-5">
						<b>Какво ще получите в програмата?</b>
						<ul>
							<li>14 лекции, разделени в две части (видео и текст);</li>
							<li>седмични дискусионни лайв сесии с упражнения;</li>
							<li>
								чат канал в Telegram за споделяне, въпроси и взаимна подкрепа
								между участниците;
							</li>
						</ul>
					</p>
					<p className="singlePostDesc pb-5">
						<b>Модул 1: Въведение в личните граници</b>
					</p>
					<p className="singlePostDesc pb-5">
						Какво са личните граници и защо са жизненоважни?
					</p>
					<ul className="pb-5">
						<li>
							Какво представляват личните граници и как влияят на психическото и
							емоционалното здраве;{" "}
						</li>
						<li>Очаквания и потребности в отношенията;</li>
						<li>Границите като форма на грижа за себе си;</li>
						<li>
							Как липсата на граници води до изтощение и прекомерно
							себераздаване;
						</li>
						<li>Признаци за нарушени или липсващи граници;</li>
						<li>Връзката между травмите и неспособността да казваме „НЕ“;</li>
					</ul>
					<p className="singlePostDesc pb-5">
						<b>Практически задачи:</b>
						<ul>
							<li>Самоанализ: „Как изглеждат моите граници в момента?“</li>
							<li>
								Упражнение: „Първи стъпки в идентифициране на здравословни
								граници“
							</li>
						</ul>
					</p>
					<p className="singlePostDesc pb-5">
						Модул 2: Причини за липса на граници
					</p>
					<p className="singlePostDesc pb-5">
						Защо се затрудняваме да поставяме граници?
					</p>
					<ul className="pb-5">
						<li>Влияние на семейната среда и възпитанието;</li>
						<li>Детски травми и тяхната роля в зрелите отношения;</li>
						<li>Страх от отхвърляне и конфликти;</li>
						<li>Синдром на угодничеството;</li>
						<li>Нереалистични очаквания и ролята на „супергероя“;</li>
						<li>
							Шестте вида граници: физически, емоционални, времеви, сексуални,
							интелектуални и материални;
						</li>
					</ul>
					<p className="singlePostDesc pb-5">Практически задачи:</p>
					<ul className="pb-5">
						<li>Упражнение: „В кои зони най-често правя компромиси?“</li>
						<li>
							Практика за казване на „НЕ“ – примерни сценарии и отиграване;
						</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Модул 3: Изграждане на здравословни граници
					</p>
					<p className="singlePostDesc pb-5">
						Как да разпознаваме, заявяваме и защитаваме своите граници?
					</p>
					<ul className="pb-5">
						<li>Разпознаване на собствените нужди;</li>
						<li>Уверено заявяване на желания и позиции;</li>
						<li>
							Граници в различни сфери на живота – семейство, партньорства,
							приятелства, работа, социални мрежи и технологии;
						</li>
						<li>Техники за управление на конфликтни ситуации;</li>
					</ul>
					<p className="singlePostDesc pb-5">Практически задачи:</p>
					<ul className="pb-5">
						<li>
							Упражнение: „Как да поставя граници в различни сфери на живота?“
						</li>
						<li>Медитация: „Здравословно лично пространство“</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Модул 4: Поддържане на вътрешния мир
					</p>
					<p className="singlePostDesc pb-5">
						Как да живеем в баланс, без да се жертваме?
					</p>
					<ul className="pb-5">
						<li>Границите като част от ежедневието;</li>
						<li>Адаптиране на границите с промените в живота;</li>
						<li>Как да реагираме, когато границите са нарушени;</li>
						<li>Разпознаване на манипулации и токсично поведение;</li>
						<li>Свободата да бъдеш себе си и да живееш автентично;</li>
					</ul>
					<p className="singlePostDesc pb-5">Практически задачи:</p>
					<ul className="pb-5">
						<li>Ритуал: „Прощавам и освобождавам“</li>
						<li>Създаване на личен манифест за баланс и вътрешен мир</li>
					</ul>
					<p className="singlePostDesc pb-5">
						Програмата включва 14 лекции, които можете да гледате и четете в
						удобно за вас време, седмични лайв сесии (по 1 час) за въпроси и
						практика, както и постоянна подкрепа чрез чат канал в Telegram.
					</p>
					<p className="singlePostDesc pb-5">
						В края на програмата ще имате ясно разбиране какво са личните
						граници и защо са от съществено значение за качеството на вашия
						живот. Ще научите как да разпознавате и заявявате своите нужди, да
						изграждате нови здравословни модели на комуникация и да живеете с
						повече вътрешен мир, увереност и баланс – без да се жертвате.
					</p>
					<p className="singlePostDesc">
						Програмата стартира на 1-во число всеки месец. Това е покана да
						направите първата стъпка към по-спокоен живот.
					</p>
				</>
			),
		programImage: programImage1,
	},
	{
		id: "toxic-relationships",
		nameKey: "programs.p2_short_name",
		image: programImage2,
		shortDescKey: "programs.p2_short_desc",
		description: (lang) =>
			lang === "en" ? (
				<div className="program-full-description">
					<p className="singlePostDesc pb-5">
						This online program is a deep transformational journey for people
						who repeatedly find themselves in toxic, emotionally draining, or
						narcissistic relationships and want not only to leave them, but to
						break the pattern permanently. The program combines psychological
						work, coaching tools, emotional release practices, and rituals for a
						new beginning.{" "}
					</p>
					<p className="singlePostDesc pb-5">
						Module 1: Understanding the Problem
					</p>
					<p className="singlePostDesc pb-5">
						Why do we attract narcissistic partners?
					</p>
					<p className="singlePostDesc pb-5">Goals</p>
					<ul className="pb-5">
						<li>Understanding narcissistic traits and relationship dynamics</li>
						<li>Identifying personal trauma that binds us to such partners</li>
						<li>
							Exploring the role of childhood, family patterns, and codependency
						</li>
					</ul>
					<p className="singlePostDesc pb-5">Content</p>
					<ul className="pb-5">
						<li>What is narcissism?</li>
						<ul className="pb-5">
							<li>Core characteristics of a narcissistic partner</li>
							<li>
								Relationship phases: idealization, devaluation, and discard
							</li>
						</ul>
						<li>What attracts us to narcissistic partners?</li>
						<ul className="pb-5">
							<li>The influence of family dynamics and childhood trauma</li>
							<li>Low self-esteem and the need for external validation</li>
						</ul>
						<li>Self-anaysis: What is my role?</li>
						<ul className="pb-5">
							<li>Test to identify personal relationship patterns</li>
						</ul>
					</ul>
					<p className="singlePostDesc">Practical exercises:</p>
					<ul className="pb-10">
						<li>
							Journaling: “What childhood patterns do I recognize in my
							relationships?”
						</li>
						<li>Creating a list of narcissistic “red flags”</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Module 2: Personal Boundaries and Emotional Freedom
					</p>
					<p className="singlePostDesc pb-5">How do we exit the toxic cycle?</p>
					<p className="singlePostDesc pb-5">Goals</p>
					<ul className="pb-5">
						<li>Recognizing manipulation tactics</li>
						<li>Strengthening personal boundaries</li>
						<li>Developing confidence and independence</li>
					</ul>
					<p className="singlePostDesc pb-5">Content</p>
					<ul className="pb-5">
						<li>Manipulative tactics of narcissistic partners</li>
						<ul className="pb-5">
							<li>Gaslighting and how to recognize it</li>
							<li>Emotional blackmail and guilt cycles</li>
						</ul>
						<li>Setting boundaries</li>
						<ul className="pb-5">
							<li>What healthy boundaries look like</li>
							<li>Practical techniques for saying “NO”</li>
						</ul>
						<li>Working with fear of abandonment</li>
						<ul className="pb-5">
							<li>Understanding the fear</li>
							<li>Techniques for emotional stability</li>
						</ul>
					</ul>
					<p className="singlePostDesc">Practical exercises:</p>
					<ul className="pb-10">
						<li>“Boundaries I will maintain in future relationships”</li>
						<li>Boundary-strengthening visualization</li>
					</ul>

					<p className="singlePostDesc pb-5">Module 3: Healing the Trauma</p>
					<p className="singlePostDesc pb-5">
						Healing emotional wounds and restoring the self.
					</p>
					<p className="singlePostDesc pb-5">Goals</p>
					<ul className="pb-5">
						<li>Inner child healing</li>
						<li>Releasing emotional dependency</li>
						<li>Building a healthy relationship with yourself</li>
					</ul>
					<p className="singlePostDesc pb-5">Content</p>
					<ul className="pb-5">
						<li>The inner child and relationships</li>
						<ul className="pb-5">
							<li>How childhood trauma affects adult choices</li>
							<li>Inner child connection practice</li>
						</ul>
						<li>Overcoming emotional dependency</li>
						<ul className="pb-5">
							<li>Releasing the need for approval</li>
							<li>Building self-respect and independence</li>
						</ul>
						<li>Rewriting your personal story</li>
						<ul className="pb-5">
							<li>From victim to creator</li>
							<li>Changing the internal narrative</li>
						</ul>
					</ul>
					<p className="singlePostDesc">Practical exercises:</p>
					<ul className="pb-10">
						<li>Letter to the inner child;</li>
						<li>
							“What unmet needs do I have and how can I meet them myself?”
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Module 4: Release Rituals and New Beginnings
					</p>
					<p className="singlePostDesc pb-5">
						Creating healthy relationships and a strong connection with yourself
					</p>

					<p className="singlePostDesc pb-5">Goals</p>
					<ul className="pb-5">
						<li>Final release of toxic energy</li>
						<li>Creating new beliefs about love</li>
						<li>Building a vision for a healthy future</li>
					</ul>

					<p className="singlePostDesc pb-5">Content</p>
					<ul className="pb-5">
						<li>Release rituals</li>
						<ul className="pb-5">
							<li>Forgiving yourself and your partner</li>
							<li>Energetic cleansing</li>
						</ul>
						<li>Attracting a healthy relationship</li>
						<ul className="pb-5">
							<li>Recognizing a suitable partner</li>
							<li>New beliefs about love and intimacy</li>
						</ul>
						<li>Creating a meaningful future</li>
						<ul className="pb-5">
							<li>Action planning</li>
							<li>Vision for future relationships and personal growth</li>
						</ul>
					</ul>
					<p className="singlePostDesc pb-5">Practical exercises:</p>
					<ul className="pb-5">
						<li>Ritual: “I forgive and I release”</li>
						<li>Personal manifesto for love and relationships</li>
						<li>Meditation for love and inner peace</li>
					</ul>
					<p className="singlePostDesc pb-5 bold">Bonuses:</p>
					<ul className="pb-5">
						<li>Video lectures explaining each topic</li>
						<li>Workbooks with in-depth reflection exercises</li>
						<li>Group online support session</li>
						<li>Guided meditations for daily use</li>
					</ul>
					<p className="singlePostDesc pt-10">
						By the end of the program, you will release emotional trauma, build
						new healthy beliefs, and create a fulfilling life.
					</p>
				</div>
			) : (
				<div className="program-full-description">
					<p className="singlePostDesc pb-5">
						Тази онлайн програма е дълбок трансформиращ процес за хора, които
						многократно попадат в токсични, изтощаващи или нарцистични връзки и
						искат не просто да „излязат“ от тях, а да прекъснат модела завинаги.
						Програмата съчетава психологическа работа, коучинг подходи, практики
						за емоционално освобождение и ритуали за ново начало.{" "}
					</p>

					<p className="singlePostDesc pb-5">Модул 1: Разбиране на проблема</p>
					<p className="pb-5">Защо привличаме нарцистични партньори?</p>
					<p className="pb-5">Цели</p>
					<ul className="pb-5">
						<li>Разбиране на нарцистичните черти и динамиката във връзката</li>
						<li>
							Идентифициране на личните травми, които ни свързват с такива
							партньори
						</li>
						<li>
							Осъзнаване на ролята на детството, семейните модели и
							съзависимостта
						</li>
					</ul>
					<p className="singlePostDesc pb-5">Съдържание:</p>
					<ul className="pb-5">
						<li>Какво е нарцисизъм?</li>
						<ul className="pb-5">
							<li>Основни характеристики на нарцистичния партньор</li>
							<li>Фази на връзката: идеализация, девалвация и отхвърляне</li>
						</ul>
						<li>Какво ни привлича към нарцистични партньори?</li>
						<ul className="pb-5">
							<li>Влияние на семейната среда и детските травми</li>
							<li>Ниско самочувствие и нуждата от външно одобрение</li>
						</ul>
						<li>Самоанализ: Каква е моята роля?</li>
						<ul className="pb-5">
							<li>Тест за идентифициране на личните модели в отношенията</li>
						</ul>
					</ul>
					<p className="bold">Практически упражнения:</p>
					<ul className="pb-10">
						<li>
							Журналинг: „Какви модели от детството си откривам във връзките
							си?“
						</li>
						<li>Списък с „червени знамена“ за нарцистично поведение.</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Модул 2: Лични граници и емоционална свобода
					</p>

					<p className="singlePostDesc pb-5">Цели</p>
					<ul className="pb-5">
						<li>Осъзнаване на манипулативните тактики</li>
						<li>Укрепване на личните граници</li>
						<li>Развиване на самоувереност и независимост</li>
					</ul>

					<p className="singlePostDesc pb-5">Съдържание:</p>
					<ul className="pb-5">
						<li>Манипулативни тактики на нарцистичния партньор</li>
						<ul className="pb-5">
							<li>Газлайтинг – как да го разпознаем</li>
							<li>Емоционален шантаж и цикълът на вина</li>
						</ul>
						<li>Поставяне на граници</li>
						<ul className="pb-5">
							<li>Как изглеждат здравите граници</li>
							<li>Практични техники за „НЕ“ и отказване от токсични влияния</li>
						</ul>
						<li>Работа със страха от изоставяне</li>
						<ul className="pb-5">
							<li>Разбиране на страха</li>
							<li>Техники за стабилизиране и вътрешна сигурност</li>
						</ul>
					</ul>
					<p className="bold">Практически упражнения:</p>
					<ul className="pb-10">
						<li>„Граници, които ще спазвам в бъдещите си отношения“</li>
						<li>Медитация за укрепване на личните граници</li>
					</ul>
					<p className="singlePostDesc pb-5">Модул 3: Лечение на травмите</p>
					<p className="pb-5">
						<i>
							Изцеление на емоционалните рани и възстановяване на личността.
						</i>
					</p>
					<p className="singlePostDesc pb-5">Цели</p>
					<ul className="pb-5">
						<li>Работа с вътрешното дете</li>
						<li>Освобождаване от емоционалната зависимост</li>
						<li>Изграждане на здрава връзка със себе си</li>
					</ul>
					<p className="singlePostDesc pb-5">Съдържание:</p>
					<ul className="pb-5">
						<li>Вътрешното дете и връзките</li>
						<ul className="pb-5">
							<li>Как детските травми влияят на настоящите ни избори</li>
							<li>Практика за свързване с вътрешното дете</li>
						</ul>
						<li>Преодоляване на емоционалната зависимост</li>
						<ul className="pb-5">
							<li>Освобождаване от нуждата от одобрение</li>
							<li>Самоуважение и вътрешна стабилност</li>
						</ul>
						<li>Пренаписване на личната история</li>
						<ul className="pb-5">
							<li>От жертва към създател</li>
							<li>Промяна на вътрешния наратив</li>
						</ul>
					</ul>
					<p className="bold">Практически упражнения:</p>
					<ul className="pb-10">
						<li>Писмо до вътрешното дете;</li>
						<li>„Как да посрещна сама своите незадоволени нужди“.</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Модул 4: Ритуали за освобождение и ново начало
					</p>

					<p className="singlePostDesc pb-5">
						Създаване на здравословни връзки и силна връзка със себе си
					</p>

					<p className="singlePostDesc pb-5">Цели</p>
					<ul className="pb-5">
						<li>Финално освобождаване от токсичните енергии</li>
						<li>Изграждане на нови вярвания за любовта</li>
						<li>Създаване на визия за здравословен живот</li>
					</ul>

					<p className="singlePostDesc pb-5">Съдържание:</p>
					<ul className="pb-5">
						<li>Ритуали за освобождение</li>
						<ul className="pb-5">
							<li>Прощаване на себе си и партньора</li>
							<li>Енергийно изчистване</li>
						</ul>
						<li>Привличане на здравословна връзка</li>
						<ul className="pb-5">
							<li>Разпознаване на подходящ партньор</li>
							<li>Нови вярвания за любовта</li>
						</ul>
						<li>Изграждане на бъдеще със смисъл</li>
						<ul className="pb-5">
							<li>План за действие</li>
							<li>Визия за бъдещи отношения и личностно развитие</li>
						</ul>
					</ul>
					<p className="bold">Практически упражнения:</p>
					<ul className="pb-10">
						<li>Ритуал: „Прощавам и се освобождавам“</li>
						<li>Личен манифест за любов и взаимоотношения</li>
						<li>Медитация за любов и вътрешен мир</li>
					</ul>

					<p className="singlePostDesc pb-5">
						<b>Бонуси:</b>
					</p>
					<ul className="pb-5">
						<li>Видео лекции, обясняващи всяка тема</li>
						<li>Работни тетрадки с подробни задания за размисъл</li>
						<li>Групова онлайн среща за подкрепа</li>
						<li>Водени медитации за ежедневна употреба</li>
					</ul>
					<p className="singlePostDesc pt-10">
						В края на програмата ще сте освободили емоционалните травми, ще сте
						изградили нови здравословни вярвания и ще сте създали пълноценен
						живот.
					</p>

					<ul className="pb-5">
						<li>Енергийно изчистване и прощаване на себе си и партньора;</li>
						<li>
							Привличане на здравословна връзка и разпознаване на подходящ
							партньор;
						</li>
						<li>Визия за бъдещи отношения и план за личностно развитие.</li>
					</ul>

					<p className="singlePostDesc pb-5">
						<b>Бонуси:</b> Видео лекции, работни тетрадки с подробни задания,
						групова онлайн среща за подкрепа и водени медитации.
					</p>
					<p className="singlePostDesc pt-10">
						В края на програмата ще сте освободили емоционалните травми и ще сте
						изградили нови, здравословни вярвания за любовта и самите себе си.
					</p>
				</div>
			),
		programImage: programImage2,
	},
	{
		id: "chakra-detox",
		nameKey: "programs.p3_short_name",
		image: programImage3,
		shortDescKey: "programs.p3_short_desc",
		description: (lang) =>
			lang === "en" ? (
				<div className="program-full-description">
					<p className="singlePostDesc pb-5">
						The 7 Chakra Detox program is designed around balanced nutrition
						aligned with the body’s energy centers. Its purpose is to support
						physical detoxification, deepen inner awareness, and awaken life
						force energy. The program is suitable for anyone seeking a holistic
						approach to physical, emotional, and energetic wellbeing.{" "}
					</p>
					<p className="singlePostDesc pb-5">
						<b>Price:</b> 30 € per month <br />
						<b>Format:</b> Online – with access to recipes, guidance, and
						ongoing community support.
					</p>

					<p className="singlePostDesc pb-5 bold">What is included?</p>
					<ul className="pb-5">
						<li>Weekly chakra-based meal plans with daily recipes</li>
						<li>Video lectures for each chakra – its meaning and balancing</li>
						<li>
							Practical guidance for incorporating colors, aromas, and
							meditation into daily life;
						</li>
						<li>Support chat group for sharing and questions</li>
					</ul>

					<p className="singlePostDesc pb-5 bold">Program Structure</p>

					<p className="singlePostDesc pb-5">Day 1: Root Chakra (Muladhara)</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Stability, safety, and grounding
						</li>
						<li>
							<b>Foods:</b> Red foods (beetroot, red peppers, tomatoes), root
							vegetables, proteins
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Day 2: Sacral Chakra (Svadhisthana)
					</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Creativity, emotions, and pleasure
						</li>
						<li>
							<b>Foods:</b> Orange foods (pumpkin, carrots, oranges), nuts and
							seeds
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Day 3: Solar Plexus (Manipura)</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Willpower, energy, and confidence
						</li>
						<li>
							<b>Foods:</b> Yellow foods (corn, lemons, yellow peppers), grains
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Day 4: Heart Chakra (Anahata)</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Love, balance, and compassion
						</li>
						<li>
							<b>Foods:</b> Green foods (spinach, broccoli, avocado), herbs
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Day 5: Throat Chakra (Vishuddha)
					</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Communication and authentic self-expression
						</li>
						<li>
							<b>Foods:</b> Blue and purple foods (blueberries, blackberries,
							plums), fluids
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Day 6: Third Eye Chakra (Ajna)</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Intuition and clarity
						</li>
						<li>
							<b>Foods:</b> Dark blue and purple foods (eggplant, plums),
							healthy fats
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Day 7: Crown Chakra (Sahasrara)</p>
					<ul className="pb-5">
						<li>
							<b>Focus:</b> Connection to higher consciousness
						</li>
						<li>
							<b>Foods:</b> Light foods, herbal teas, optional fasting
						</li>
					</ul>

					<p className="singlePostDesc pb-5 bold">Additional Resources:</p>
					<ul className="pb-5">
						<li>Guided meditations for each chakra (audio)</li>
						<li>Personal journal for tracking the process</li>
						<li>Weekly shopping lists</li>
					</ul>

					<p className="singlePostDesc pt-10">
						The program is suitable for both beginners and those with experience
						in energy work who want to deepen their practice and bring more
						balance to their daily lives.
					</p>
				</div>
			) : (
				<div className="program-full-description">
					<p className="singlePostDesc pb-5">
						Детокс програмата за 7-те чакри е създадена на основата на
						балансирано хранене, съобразено с енергийните центрове на тялото.
						Целта на програмата е да подпомогне изчистването на токсините, да
						задълбочи връзката с вътрешния свят и да активира жизнената енергия.
						Тя е подходяща за хора, които търсят цялостен подход към
						физическото, емоционалното и енергийното здраве.
					</p>
					<p className="singlePostDesc pb-5">
						<b>Цена:</b> 30 € на месец <br />
						<b>Форма на провеждане:</b> Онлайн – с достъп до рецепти, насоки и
						поддържаща общност.
					</p>

					<p className="singlePostDesc pb-5 bold">Какво включва програмата?</p>
					<ul className="pb-5">
						<li>
							Седмично меню, изградено според чакрите, с рецепти за всеки ден
						</li>
						<li>
							Видео лекции за всяка чакра – нейното значение и начини за
							балансиране
						</li>
						<li>
							Практически насоки за работа с цветове, аромати и медитации в
							ежедневието
						</li>
						<li>Чат група за подкрепа, споделяне и въпроси</li>
					</ul>

					<p className="singlePostDesc pb-5 bold">Структура на програмата</p>

					<p className="singlePostDesc pb-5">
						Ден 1: Коренна чакра (Муладхара)
					</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> стабилност, сигурност и заземяване
						</li>
						<li>
							<b>Храни:</b> червени храни (цвекло, червена чушка, домати),
							кореноплодни зеленчуци, протеини
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Ден 2: Сакрална чакра (Свадхищхана)
					</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> креативност, емоции и удоволствие
						</li>
						<li>
							<b>Храни:</b> оранжеви храни (тиква, моркови, портокали), ядки и
							семена
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Ден 3: Слънчев сплит (Манипура)</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> воля, енергия и увереност
						</li>
						<li>
							<b>Храни:</b> жълти храни (царевица, лимони, жълта чушка), зърнени
							храни
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Ден 4: Сърдечна чакра (Анахата)</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> любов, баланс и състрадание
						</li>
						<li>
							<b>Храни:</b> зелени храни (спанак, броколи, авокадо), билки
						</li>
					</ul>

					<p className="singlePostDesc pb-5">Ден 5: Гърлена чакра (Вишудха)</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> комуникация и автентично изразяване
						</li>
						<li>
							<b>Храни:</b> сини и лилави храни (боровинки, къпини, сливи),
							течности
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Ден 6: Чакра на третото око (Аджна)
					</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> интуиция и яснота
						</li>
						<li>
							<b>Храни:</b> тъмносини и лилави храни (патладжан, сини сливи),
							здравословни мазнини
						</li>
					</ul>

					<p className="singlePostDesc pb-5">
						Ден 7: Коронна чакра (Сахасрара)
					</p>
					<ul className="pb-5">
						<li>
							<b>Фокус:</b> връзка с висшето съзнание
						</li>
						<li>
							<b>Храни:</b> леки храни, чайове, постене (по избор)
						</li>
					</ul>

					<p className="singlePostDesc pb-5 bold">Допълнителни ресурси:</p>
					<ul className="pb-5">
						<li>Водени медитации за всяка чакра (аудио файлове)</li>
						<li>Личен дневник за проследяване на процеса</li>
						<li>Седмични списъци за пазаруване</li>
					</ul>

					<p className="singlePostDesc pt-10">
						Програмата е подходяща както за начинаещи, така и за хора с опит в
						енергийна работа, които искат да задълбочат практиката си.
					</p>
				</div>
			),
		programImage: programImage3,
	},
];

// { programInfo };

/*
const programInfo = [
	{
		id: "personal-boundaries",
		programName: `Онлайн програма: "Постави граници и заживей във вътрешен мир"`,
		programShortName: "Постави граници и заживей във вътрешен мир",
		programShortDesc:
			"Да се научим да поставяме лични граници в общуването с хората и света около нас е ключов елемент за постигане на вътрешен мир и емоционално здраве. ",
		programDescription: (
			<>
				<p className="singlePostDesc pb-5">
					<b>Описание на програмата:</b> Да се научим да поставяме
					лични граници в общуването с хората и света около нас е
					ключов елемент за постигане на вътрешен мир и емоционално
					здраве. Тази едномесечна програма ще ви помогне да разберете
					същността на границите, да идентифицирате причините за
					техния недостиг и да изградите нови умения, които ще
					подобрят вашите взаимоотношения и качеството на живота ви.
				</p>
				<p className="singlePostDesc pb-5">
					<b>Какво ще получите в програмата?</b>
					<ul>
						<li>
							1. <b>14 лекции</b>, разделени в две части.
						</li>
						<li>
							2. <b>Дискусионни лайф сесии</b> веднъж седмично с
							практически упражнения.
						</li>
						<li>
							3. <b>Чат канал за общуване</b> и подкрепа в
							Телеграм.
						</li>
					</ul>
				</p>
				<br />
				<p className="singlePostDesc pb-5">
					<b>Модул 1: Въведение в личните граници</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Какво са личните граници и защо са важни?
					<b>Съдържание:</b>
					<ul>
						<li>
							1. <b>Определение за лични граници:</b>
							<ul>
								<li>
									- Какво представляват границите и как влияят
									на емоционалното и психическото здраве.
								</li>
								<li>
									- Очаквания и потребности в отношенията.
								</li>
							</ul>
						</li>
						<li>
							2. <b>Смисълът на границите:</b>
							<ul>
								<li>- Защо те са форма на грижа за себе си.</li>
								<li>
									- Как границите предпазват от изтощение и
									прекомерно себераздаване.
								</li>
							</ul>
						</li>
						<li>
							3. <b>Как изглеждат нарушените граници:</b>
							<ul>
								<li>
									- Признаци и последици от замъглените или
									липсващи граници.
								</li>
								<li>
									- Връзката между травмите и неспособността
									да казваме "НЕ".
								</li>
							</ul>
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически задачи:</b>
					<ul>
						<li>
							- Самоанализ: "Как изглеждат моите граници в
							момента?"
						</li>
						<li>
							- Упражнение: "Първи стъпки в идентифициране на
							здравословни граници."
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Модул 2: Причини за липса на граници</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Защо се затрудняваме да поставяме граници?
				</p>
				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					<ul>
						<li>
							1. <b>Корени на проблема:</b>
							<ul>
								<li>
									- Влияние на семейната среда и възпитанието.
								</li>
								<li>
									- Травми от детството и как те формират
									трудности при поставянето на граници.
								</li>
							</ul>
						</li>
						<li>
							2. <b>Често срещани пречки:</b>
							<ul>
								<li>- Страх от отхвърляне и конфликти.</li>
								<li>
									- Желание да се харесаме на другите (синдром
									на угодничество).
								</li>
								<li>
									- Нереалистични очаквания към себе си и
									ролята на "супергерой".
								</li>
							</ul>
						</li>
						<li>
							3. <b>Шестте вида граници:</b>
							<ul>
								<li>
									- Физически, емоционални, времеви,
									сексуални, интелектуални и материални
									граници.
								</li>
							</ul>
						</li>
					</ul>
					<p className="singlePostDesc pb-5">
						<b>Практически задачи:</b>
					</p>
					<ul>
						<li>
							- Упражнение: "Идентифициране на зоните, в които
							най-често правя компромиси."
						</li>
						<li>
							- Практика за казване на "НЕ": Примерни сценарии и
							тяхното отиграване.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Модул 3: Изграждане на здравословни граници</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Как да разпознаваме, заявяваме и защитаваме
					границите си?
				</p>
				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
				</p>
				<p className="singlePostDesc pb-5">
					1. <b>Как да поставяме ясни граници:</b>
					<ul>
						<li>- Разпознаване на собствените нужди.</li>
						<li>
							- Изграждане на увереност да заявяваме желанията си.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.<b>Граници в различни сфери на живота:</b>
					<ul>
						<li>- Семейство.</li>
						<li>- Романтични отношения.</li>
						<li>- Приятелства.</li>
						<li>- Работно място.</li>
						<li>- Социални медии и технологии.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Как да запазим границите си пред другите:</b>
					<ul>
						<li>- Уверено изразяване на нуждите си.</li>
						<li>- Техники за управление на конфликтни ситуации.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически задачи:</b>
					<ul>
						<li>
							- Упражнение: "Направете списък с нови граници за
							всяка сфера на живота."
						</li>
						<li>
							- Медитация: "Визуализиране на здравословно
							пространство около себе си."
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Модул 4: Поддържане на вътрешния мир</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Как да живеем в баланс, без да жертваме себе
					си?
				</p>
				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					1. <b>Границите като част от живота:</b>
					<ul>
						<li>- Превръщане на поставянето на граници в навик.</li>
						<li>
							- Постоянно оценяване и адаптиране на границите.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.
					<b>Какво да правим, когато границите ни бъдат нарушени:</b>
					<ul>
						<li>
							- Разпознаване на манипулация и токсично поведение.
						</li>
						<li>
							- Техники за възстановяване на нарушените граници.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Свободата да бъдем себе си:</b>
					<ul>
						<li>
							- Как границите ви помагат да живеете автентично.
						</li>
						<li>
							- Създаване на визия за живот с уважение към
							собствените нужди.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически задачи:</b>
					<ul>
						<li>
							- Ритуал за освобождаване от емоционалния товар:
							"Прощавам и се освобождавам."
						</li>
						<li>
							- Създаване на личен манифест за баланс и вътрешен
							мир.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Как протича програмата?</b>
					<ul>
						<li>
							1. <b>14 лекции:</b>
							<br />- Видеа и текстови материали, които можете да
							гледате и четете в удобно за вас време.
						</li>
						<li>
							2. <b>Дискусионни лайф сесии:</b>
							<br />- Всяка седмица (по 1 час) ще имате възможност
							да задавате въпроси и да работите върху практически
							задачи с моя подкрепа.
						</li>
						<li>
							3. <b>Чат канал за дискусии:</b>
							<br />- Постоянна връзка с другите участници, където
							ще можете да споделяте опит и да получавате
							подкрепа.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Какво ще постигнете?</b>
					<ul>
						<li>
							- Ще разберете какво са личните граници и защо са
							важни.
						</li>
						<li>
							- Ще се научите да разпознавате и заявявате своите
							нужди.
						</li>
						<li>
							- Ще изградите нови, здравословни навици за
							комуникация.
						</li>
						<li>
							- Ще постигнете вътрешен мир и увереност, без да
							жертвате себе си.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					Програмата стартира на 1-во число всеки месец. Присъединете
					се и направете първата стъпка към по-добър и балансиран
					живот!
				</p>
			</>
		),
		programImage: programImage1,
	},
	{
		id: "toxic-relationships",
		programName: `Онлайн програма: "Освободи се от токсичните връзки и изгради себе си"`,
		programShortName: "Освободи се от токсичните връзки и изгради себе си",
		programShortDesc: "",
		programDescription: (
			<>
				<p className="singlePostDesc pb-5">
					<b>Модул 1: Разбиране на проблема</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Защо привличаме нарцистични партньори?
				</p>
				<p className="singlePostDesc pb-5">
					<b>Цели:</b>
					<ul>
						<li>
							- Разбиране на нарцистичните черти и динамиката във
							връзката.
						</li>
						<li>
							- Идентифициране на личните травми, които ни
							свързват с тези партньори.
						</li>
						<li>
							- Разбиране на ролята на детството, семейните модели
							и съзависимостта.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					1. <b>Какво е нарцисизъм?</b>
					<ul>
						<li>
							- Основни характеристики на нарцистичния партньор.
						</li>
						<li>
							- Фази на връзката: идеализация, девалвация и
							отхвърляне.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.
					<b>Какво ни привлича към нарцистичните партньори?</b>
					<ul>
						<li>
							- Влиянието на семейната среда и детските травми.
						</li>
						<li>
							- Ролята на ниската самооценка и нуждата от
							одобрение.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Самоанализ: Каква е моята роля?</b>
					<ul>
						<li>
							- Тест за идентифициране на вашите модели на
							поведение във връзките.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически упражнения:</b>
					<ul>
						<li>
							- Журналинг: "Какви модели от детството си откривам
							във връзките си?"
						</li>
						<li>
							- Създаване на списък с "червени знамена" за
							нарцистично поведение.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Модул 2: Лични граници и емоционална свобода</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Как да излезем от токсичния цикъл?
				</p>
				<p className="singlePostDesc pb-5">
					<b>Цели:</b>
					<ul>
						<li>
							- Осъзнаване на манипулативните тактики на
							нарцистичния партньор.
						</li>
						<li>- Укрепване на личните граници.</li>
						<li>- Развиване на самоувереност и независимост.</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					1. <b>Манипулативните тактики на нарцистичния партньор:</b>
					<ul>
						<li>- Газлайтинг: Какво е и как да го разпознаем?</li>
						<li>- Емоционален шантаж и цикълът на вина.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.
					<b>Как да поставяме граници:</b>
					<ul>
						<li>- Какво представляват здравите граници?</li>
						<li>
							- Практични техники за "НЕ" и отказване от токсични
							влияния.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Как да се справим със страха от изоставяне:</b>
					<ul>
						<li>- Разбиране на страха.</li>
						<li>- Техники за работа с вътрешната несигурност.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически упражнения:</b>
					<ul>
						<li>
							- Практика: Написване на "Граници, които ще спазвам
							в бъдещи отношения".
						</li>
						<li>
							- Медитация: Визуализация за укрепване на личните
							граници.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Модул 3: Лечение на травмите</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Лечение на емоционалните рани и възстановяване
					на личността.
				</p>
				<p className="singlePostDesc pb-5">
					<b>Цели:</b>
					<ul>
						<li>
							- Работа с вътрешното дете и травмите от миналото.
						</li>
						<li>
							- Преодоляване на зависимостта от одобрението на
							другите.
						</li>
						<li>
							- Изграждане на здравословна връзка със себе си.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					1. <b>Връзка с вътрешното дете:</b>
					<ul>
						<li>
							- Как травмите от детството влияят на настоящите ни
							връзки.
						</li>
						<li>- Практика за свързване с вътрешното дете.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.
					<b>Преодоляване на емоционалната зависимост:</b>
					<ul>
						<li>- Как да се освободим от нуждата от одобрение.</li>
						<li>- Изграждане на независимост и самоуважение.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Пренаписване на личната история:</b>
					<ul>
						<li>
							От жертва към създател: Промяна на личния наратив.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически упражнения:</b>
					<ul>
						<li>- Журналинг: Писмо до вътрешното дете.</li>
						<li>
							- Практика: "Кои са моите незадоволени нужди и как
							мога да ги задоволя сама?"
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Модул 4: Ритуали за освобождение и ново начало</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Тема:</b> Създаване на здрави взаимоотношения и връзка
					със себе си.
				</p>
				<p className="singlePostDesc pb-5">
					<b>Цели:</b>
					<ul>
						<li>- Финално освобождаване от токсичните енергии.</li>
						<li>
							- Изграждане на нови вярвания за любов и
							взаимоотношения.
						</li>
						<li>- Създаване на визия за здравословен живот.</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Съдържание:</b>
					1. <b>Ритуали за освобождение:</b>
					<ul>
						<li>- Прощаване на себе си и партньора.</li>
						<li>- Ритуал за енергийно изчистване.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					2.
					<b>Привличане на здравословна връзка:</b>
					<ul>
						<li>
							- Как да разпознаем и привлечем подходящ партньор.
						</li>
						<li>- Нови вярвания за любов и взаимоотношения.</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					3.<b>Изграждане на бъдеще със смисъл:</b>
					<ul>
						<li>Създаване на план за действие.</li>
						<li>
							Изграждане на визия за бъдещи отношения и личностно
							развитие.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Практически упражнения:</b>
					<ul>
						<li>- Ритуал: "Прощавам и се освобождавам."</li>
						<li>
							- Създаване на личен манифест за любов и
							взаимоотношения.
						</li>
						<li>
							- Медитация: Привличане на любов и вътрешен мир.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Бонуси:</b>
					<ul>
						<li>
							- <b>Видео лекции:</b>Обяснителни сесии за всяка
							тема.
						</li>
						<li>
							- <b>Работни тетрадки:</b>Подробни задания и въпроси
							за рефлексия.
						</li>
						<li>
							- <b>Групова среща:</b>Онлайн среща за подкрепа и
							споделяне с други участници.
						</li>
						<li>
							- <b>Водени медитации:</b>Записи, които да се
							използват ежедневно.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Краен резултат:</b>
				</p>
				<p className="singlePostDesc pb-5">
					Участниците ще се научат да:
					<ul>
						<li>
							- Разбират причините за своите връзки с нарцистични
							партньори.
						</li>
						<li>
							- Освобождават емоционалните травми и изграждат
							нови, здравословни вярвания.
						</li>
						<li>
							- Привличат хармонични връзки и водят пълноценен
							живот.
						</li>
					</ul>
				</p>
			</>
		),
		programImage: programImage2,
	},

	{
		id: "chakra-detox",
		programName: `Онлайн програма: "Детокс за 7-те чакри"`,
		programShortName: "Детокс за 7-те чакри",
		programShortDesc:
			"Детокс програмата за 7-те чакри е разработена на база балансирано хранене, съобразено с енергийните центрове на тялото. Целта е да изчистите токсините от тялото, да се свържете с вътрешния си свят и да събудите жизнената си енергия. Програмата е подходяща за всички, които искат да съчетаят физическо, емоционално и духовно здраве.",
		programDescription: (
			<>
				<p className="singlePostDesc pb-5">
					<b>Описание на програмата</b>
				</p>
				<p className="singlePostDesc pb-5">
					Детокс програмата за 7-те чакри е разработена на база
					балансирано хранене, съобразено с енергийните центрове на
					тялото. Целта е да изчистите токсините от тялото, да се
					свържете с вътрешния си свят и да събудите жизнената си
					енергия. Програмата е подходяща за всички, които искат да
					съчетаят физическо, емоционално и духовно здраве.
				</p>
				<p className="singlePostDesc pb-5">
					<b>Цена:</b> 50 лева на месец
				</p>
				<p className="singlePostDesc pb-5">
					<b>Начин на провеждане:</b> Онлайн, с достъп до рецепти,
					насоки и поддръжка.
				</p>
				<p className="singlePostDesc pb-5">
					<b>Какво включва програмата?</b>
					<ul>
						<li>
							1. <b>Седмично меню</b>, базирано на чакрите, с
							рецепти за всеки ден.
						</li>
						<li>
							2. <b>Видео лекции</b> за всяка чакра – нейното
							значение и начин на балансиране.
						</li>
						<li>
							3. <b>Практически насоки</b> за включване на
							цветове, аромати и медитации към ежедневието.
						</li>
						<li>
							4. <b>Чат група</b> за подкрепа и въпроси.
						</li>
					</ul>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Структура на програмата</b>
				</p>
				<p className="singlePostDesc pb-5">
					<b>Ден 1: Коренна чакра (Мулатхара)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Стабилност, сигурност и заземяване.
						</li>
						<li>
							- <b>Храни:</b>Червени храни (цвекло, червена чушка,
							домати), кореноплодни зеленчуци, протеини.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 2: Сакрална чакра (Свадхищхана)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Креативност, емоции и удоволствие.
						</li>
						<li>
							- <b>Храни:</b>Оранжеви храни (тиква, моркови,
							портокали), ядки и семена.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 3: Слънчев сплит (Манипура)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Воля, енергия и увереност.
						</li>
						<li>
							- <b>Храни:</b>Жълти храни (царевица, лимони, жълта
							чушка), зърнени храни.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 4: Сърдечна чакра (Анахата)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Любов, баланс и състрадание.
						</li>
						<li>
							- <b>Храни:</b> Зелени храни (спанак, броколи,
							авокадо), билки.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 5: Гърлена чакра (Вишудха)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Комуникация и изразяване.
						</li>
						<li>
							- <b>Храни:</b> Сини и лилави храни (боровинки,
							къпини, сливи), течности.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 6: Чакра на третото око (Аджна)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Интуиция и яснота.
						</li>
						<li>
							- <b>Храни:</b> Тъмносини и лилави храни (патладжан,
							сини сливи), здравословни мазнини.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Ден 7: Коронна чакра (Сахасрара)</b>
					<ul>
						<li>
							- <b>Фокус:</b> Връзка с висшето съзнание.
						</li>
						<li>
							- <b>Храни:</b> Леки храни, чайове, постене (по
							избор).
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Допълнителни ресурси:</b>
					<ul>
						<li>
							- Медитации за всяка чакра (достъпни като аудио
							файлове).
						</li>
						<li>- Личен дневник за проследяване на процеса.</li>
						<li>- Списъци за пазаруване за всяка седмица.</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					<b>Как да се включите?</b>
					<ul>
						<li>1. Регистрирайте се на сайта ни.</li>
						<li>2. Заплатете месечната такса от 50 лева.</li>
						<li>
							3. Получете достъп до платформата с всички
							материали.
						</li>
					</ul>
				</p>

				<p className="singlePostDesc pb-5">
					Присъединете се към "Детокс за 7-те чакри" и трансформирайте
					енергията и живота си още днес!
				</p>
			</>
		),
		programImage: programImage3,
	},
];

export { programInfo };
*/
